import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';

const CompanyRoute = () => {
    const { activeRole, isAuthenticated, loading } = useAuth();
    const location = useLocation();

    // اگر در حال لود شدن است، یک صفحه ساده یا لودینگ نشان بده
    if (loading) {
        return <div style={{ textAlign: 'center', padding: '50px' }}>در حال بارگذاری...</div>;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (activeRole !== 'company') {
        return <Navigate to="/unauthorized" replace />;
    }

    return <Outlet />;
};

export default CompanyRoute;